import React from 'react';
import PropTypes from 'prop-types';

import { ENERGY_CERTIFICATION_LABEL_SIZES } from '@spa/shared/constants/energyCertificationLabelSizes';
import { Wrapper } from './styles';

const { large } = ENERGY_CERTIFICATION_LABEL_SIZES;

const EnergyCertificationLabel = ({ grade, size = large }) => (
  <Wrapper grade={grade.toLowerCase()} size={size}>
    {grade}
  </Wrapper>
);

EnergyCertificationLabel.propTypes = {
  grade: PropTypes.string.isRequired,
  size: PropTypes.oneOf(Object.values(ENERGY_CERTIFICATION_LABEL_SIZES))
};

export default EnergyCertificationLabel;
